import React from 'react';
import { HeaderSpan, VisitDetailTableWrapper, VisitDetailDiv } from './WrapperDiv';
export const VisitDetail = ({
  details,
  mapper,
  title,
  editing,
  headerStyle,
  renderEditComponent,
  summary
}) => {
  const getDetails = data => mapper && mapper(data);

  return /*#__PURE__*/React.createElement(VisitDetailTableWrapper, {
    className: "visit-detail-table-wrapper"
  }, /*#__PURE__*/React.createElement(VisitDetailDiv, {
    $summary: summary
  }, /*#__PURE__*/React.createElement(HeaderSpan, {
    style: headerStyle || {}
  }, `${title}:`), /*#__PURE__*/React.createElement("div", null, editing ? renderEditComponent && renderEditComponent() : details != null && getDetails(details))));
};